// extracted by mini-css-extract-plugin
export var carrierIcon = "_xo-0";
export var carrierLogo = "_xo-1";
export var detailsSection = "_xo-2";